import { Button, Typography } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { ResponseSuscriptorDataGeneralDatum } from "../../../types/common";
import SwipeableButton from "../../../components/SwipeableButton";
const { Text } = Typography;

interface Props {
    item: ResponseSuscriptorDataGeneralDatum,
    handleCancel: Function,
    handleRemove: Function,
    isReset: boolean
}

const RemoveContract = (props: Props) => {
    const { item, handleCancel, handleRemove, isReset } = props;

    return (
        <>
            <div style={styles.divRoot}>
                <Text style={styles.textTitle}>Desasociar Contrato Asociado</Text>
                <Text style={{ fontWeight: 'bold' }}>¡Estimado usuario!</Text>
                <Text>Para desasociar al suscriptor: </Text>
                <Text style={styles.textSuscriptor}>{item.sucursal + item.suscriptor}</Text>
                <Text>Por favor deslice el botón hacia la derecha para confirmar</Text>
            </div>
            <div style={styles.containerButtons}>
                <div style={styles.swipView}>
                    <SwipeableButton
                        resetStatus={isReset}
                        onSuccess={() => handleRemove(item.sucursal, item.suscriptor)}
                        color='#0055c2'
                        text='Deslice para confirmar'
                    />
                </div>
                <Button
                    size='large'
                    style={styles.buttonPrimary}
                    onClick={() => handleCancel()}
                >
                    {"Cancelar"}
                </Button>
            </div>
        </>
    );
};

const styles = StyleSheet.create({
    divRoot: {
        textAlign: 'center',
        display: 'flex',
        width: "100%",
        flexDirection: 'column',
    },
    buttonPrimary: {
        backgroundColor: '#0055c2',
        borderRadius: 30,
        color: 'white',
        border: "none",
        padding: "5px 30px",
        height: 35,
    },
    containerButtons: {
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textTitle: {
        fontWeight: 600,
        fontSize: 20
    },
    textSuscriptor: {
        color: "#0055c2",
        fontWeight: 'bold'
    },
    swipView: {
        width: 300,
        margin: "20px 0px 20px 0px"
    }
});

export default RemoveContract;
